export const NAVIGATION_COLUMNS = {
	name: "name",
	url: "link_mm2nxe13",
	iconName: "text_mm2nbbdq",
	active: "boolean_mm2nh855",
} as const;
